import { ErrorState } from '@gymcoach/ui';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { isStaleBuildError, reloadForNewBuild } from '@/lib/staleBuild';

import { NotFoundPage } from './NotFoundPage';

/**
 * A screen that crashed or failed to load (a lazy chunk after a deploy, a render error).
 * Instead of a blank page, the person gets the error in words and a way to retry.
 * A chunk of an older build reloads the page by itself (lib/staleBuild.ts). Anything
 * else shows its technical message under "Details", so a screenshot says what broke.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  const stale = isStaleBuildError(error);
  useEffect(() => {
    if (stale) reloadForNewBuild();
  }, [stale]);
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  const detail = error instanceof Error ? `${error.name}: ${error.message}` : null;
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4">
      <ErrorState error={error} onRetry={() => window.location.reload()} />
      {detail && (
        <details className="-mt-6 max-w-lg text-center text-xs text-ink-subtle">
          <summary className="cursor-pointer">Details</summary>
          <p className="mt-1 break-words font-mono">{detail}</p>
        </details>
      )}
    </div>
  );
}
